<template>
  <div id="EquipamentoPessoa">
    <div class="row">
      <div class="col-md-6">
        <span>
          <div>
            <span class="badge badge-secondary badge-pill ">
              {{equipamento.tipo_equipamento.descricao}} 
            </span>
            {{equipamento.marca_modelo}}
          </div>
          <span class="text-muted" v-if="equipamento.imei1">
          IMEI: {{equipamento.imei1}}<span v-if ="equipamento.imei2">/{{equipamento.imei2}}</span>
          </span>
          <span class="text-muted" v-if="equipamento.num_serie">
          NS: {{equipamento.num_serie}}
          </span> 
        </span>
        <div class="container title-pessoa row">
          <span class="alert alert-primary">
            {{pessoa.nome_razao}} ({{pessoa.unid_neg.descricao}})
          </span>
        </div>
        <button class="btn btn-primary btn-sm" type="cancel" @click="onAdd()">Remover Atribuição</button>
      </div>
      <div  class="col-md-6">
        <div class="container">
          <div class="card">
            <div class="card-header text-center">
              Histórico
            </div>
            <div class="table-responsive ">
              <table class="table  table-bordered table-sm">
                <tbody>
                  <tr v-for="obj in pessoaEquipamentos" v-bind:key="obj.id">
                    <td>
                      <div>
                        <span class="badge badge-pill" v-bind:class="{ 'badge-primary': obj.acao == 'add', 'badge-danger': obj.acao == 'rem' }" >
                          {{obj.data | formatDateTime}} 
                        </span>
                        <span class="small">
                        {{obj.observacao}} - {{obj.pessoa_nome}}
                        </span>
                      </div>
                    </td>            
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <slot name="footer">
        <button class="btn btn-cancel" type="cancel" @click="closeModal($event)">Cancelar</button>
      </slot>
    </div>
  </div>
</template>

<script>

const fb = require('../../config/db.js')

export default {
  name: 'EquipamentoPessoa',
  props: ["equipamentoId"],
  data(){
    return{
      observacao: '',
      errors: [],
      pessoa: {'nome_razao': '', 'unid_neg': { 'descricao' : '' }},
      pessoaEquipamentos: [],
      pessoaEquipamento: {},
      equipamento: {
          'tipo_equipamento' : { 'idtipo_equipamento' : "", 'descricao' : '' }, 
          'marca_modelo' : "", 
          'imei1' : "", 
          'imei2' : "", 
          'num_serie' : "",
          'num_nota' : "", 
          'data_nota' : "", 
          'valor' : "", 
          'fornecedor' : "", 
          'data_entrada' : '',  
          'pessoa_id' : '',  
        },
    }
  },
  created(){
    this.getEquipamento();
    this.getHistorico();
  },
  methods: {
    getEquipamento(){
      var equipamento = [];
      fb.Equipamento.doc(this.equipamentoId).onSnapshot(p => {
        equipamento = p.data();
        equipamento.id = p.id;
        this.equipamento = equipamento;
        var pessoa = {}
        fb.Pessoas.doc(equipamento.pessoa_id).onSnapshot(e => {
          pessoa = e.data();
          pessoa.id = e.id;
          this.pessoa = pessoa;
        })
      });      
    },
    closeModal(){
      this.$emit('list-closeModal');
    },
    getHistorico(){
      fb.PessoaEquipamento.where('equipamento_id', '==', this.equipamentoId).orderBy('data_system', 'desc').orderBy('acao', 'desc').get().then(querySnapshot =>{
        const objects = []
        querySnapshot.forEach((doc)=>{
          this.pessoaEquipamento =  doc.data();
          this.pessoaEquipamento.id = doc.id;
          objects.push(this.pessoaEquipamento);
        });
        this.pessoaEquipamentos = objects;
      });
    },
    onAdd(){
      if (confirm("Deseja remover esse equipamento?") ){
        fb.PessoaEquipamento.add({
          'acao': 'rem',
          'pessoa_id': this.pessoa.id,
          'pessoa_nome': this.pessoa.nome_razao,
          'equipamento_id' : this.equipamentoId,
          'observacao': 'REMOÇÃO RÁPIDA',
          'data': new Date(),
          'data_system': new Date(),
          'usuario_acao': fb.auth.currentUser.email
        });
      
        fb.Equipamento.doc(this.equipamentoId).update({
          'pessoa_id': null,
          'pessoa_nome': ''
        });
      }
      this.closeModal();
    },
  }
 
}
</script>
<style scoped>
  .title-pessoa{
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>

